import { VFab } from 'vuetify/lib/components/index.mjs';

const fabDefaults: Partial<VFab> = {
  variant: 'flat',
  rounded: true,
};

export default fabDefaults;
